import { FC } from 'react';
import { Chip, Avatar } from '@mui/material';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { ContactReference, UserBase } from '@/types/study-company-briefings';
import styles from './briefingcard.module.css';

function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
}

// For just the time
function formatTime(dateString: string): string {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }).format(date);
}

interface BriefingProps {
  start_time: string;
  company_name: string;
  organizer: string;
  arc_attendees: UserBase[];
  contact_attendees: ContactReference[];
}

const BriefingCard: FC<BriefingProps> = ({
  start_time,
  company_name,
  organizer,
  arc_attendees,
  contact_attendees,
}) => {
  return (
    <div className={styles.briefingDetails}>
      {/* <List> */}
      {/* <ListItem disablePadding> */}
      <h3 className={styles.briefingCompany}>{company_name}</h3>
      <h3 className={styles.briefingOrganizer}>Organized by: {organizer}</h3>
      <div className={styles.briefingDateTime}>
        <div className={styles.briefingDate}>
          <h6>Date</h6>
          <h5>{formatDate(start_time)}</h5>
        </div>
        <div className={styles.briefingTime}>
          <h6>Start Time</h6>
          <h5>{formatTime(start_time)}</h5>
        </div>
      </div>
      {/* <div>
            <h5>Internal Attendees ({arc_attendees.length})</h5>
            <div>
              {arc_attendees.map(item => (
                <div key={item.id}>
                  <Chip
                    size="small"
                    label={item.email}
                    avatar={<Avatar>{item.first_name[0]}</Avatar>}
                    variant="outlined"
                  />
                </div>
              ))}
            </div>
          </div>
          <div>
            <h5>External Attendees ({contact_attendees.length})</h5>
            <div>
              {contact_attendees.map(contact => (
                <div key={contact.email}>
                  <Chip
                    size="small"
                    avatar={<Avatar>{contact.first_name[0]}</Avatar>}
                    label={contact.email}
                    variant="outlined"
                  />
                </div>
              ))}
            </div>
          </div> */}
      {/* </ListItem> */}
      {/* </List> */}
    </div>
  );
};

export default BriefingCard;
